import { APP_CONFIG } from '@/constants/app';
import { DashboardResponse } from '@/types/dashboard.types';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

// Create axios instance for dashboard service
const dashboardApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(dashboardApi);

export const dashboardService = {
  getDashboardStats: async (): Promise<DashboardResponse> => {
    const response = await dashboardApi.get<DashboardResponse>(
      '/users/dashboard-stats',
    );
    return response.data;
  },
};
